









import { defineComponent } from "@vue/composition-api";
import { PromotedUsersTab } from "../../types";

export default defineComponent({
  name: "PromotedUsersTabs",
  props: {
    activeTab: { type: String as () => PromotedUsersTab["value"], default: "all" },
  },
  data() {
    return {
      tabs: [
        {
          name: this.$t("All"),
          value: "all",
          to: { name: "discover", params: { type: "all" } },
        },
        {
          name: this.$t("Online"),
          value: "online",
          to: { name: "discover", params: { type: "online" } },
        },
        {
          name: this.$t("New"),
          value: "new",
          to: { name: "discover", params: { type: "new" } },
        },
      ] as PromotedUsersTab[],
    };
  },
});
